import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { ActiveSubscriptionModel, SubscriptionModel } from "@/features/common/api/useSubscription";

export interface SubscriptionCreateRequestModel {
	readonly planId: string;
	readonly paymentCardId: string;
	readonly promoCode: string | null;
}

export interface SubscriptionCreateResponseModel {
	readonly activeSubscription: ActiveSubscriptionModel | null;
	readonly autoRenewPaymentCardId: string | null;
	readonly autoRenewPlanId: string | null;
	readonly autoRenewPlanName: string | null;
	readonly autoRenewPlanPrice: number;
}

export const useSubscriptionCreate = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<SubscriptionCreateResponseModel>, SubscriptionCreateRequestModel> = requestModel => {
		return http<SubscriptionCreateResponseModel, SubscriptionCreateRequestModel>({
			method: "POST",
			url: "/subscription",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: data => {
			const subscription = queryClient.getQueryData<SubscriptionModel>(["subscription"]);
			queryClient.resetQueries();

			if (!subscription) {
				return;
			}

			queryClient.setQueryData<SubscriptionModel>(["subscription"], {
				...subscription,
				...data.body
			});
		}
	});
};
